import * as styles from "./DatePickerMonths.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";

import { useDatePickerContext } from "./DatePicker.context";
import type { DatePickerMonthsProps } from "./DatePicker.types";
import { DatePickerGrid } from "./DatePickerGrid";
import { DatePickerHeader } from "./DatePickerHeader";

export function DatePickerMonths({
  className,
}: DatePickerMonthsProps): JSX.Element {
  const { range, openEnd, openEnded, selectedRange, chooseOpenEnd } =
    useDatePickerContext();

  if (!range) {
    return (
      <div className={className}>
        <DatePickerHeader />
        <DatePickerGrid />
      </div>
    );
  }

  const months = (
    <div className={clsx(styles.months, className)}>
      <div className={styles.month}>
        <DatePickerHeader monthOffset={0} hideNext />
        <DatePickerGrid monthOffset={0} />
      </div>

      <span className={styles.separator} />

      <div className={styles.month}>
        <DatePickerHeader monthOffset={1} hidePrevious />
        <DatePickerGrid monthOffset={1} />
      </div>
    </div>
  );

  if (null === openEnd) {
    return months;
  }

  return (
    <div className={styles.withFooter}>
      {months}

      <div className={styles.footer}>
        <Button
          variant={openEnded ? "secondary" : "ghost"}
          size="sm"
          aria-pressed={openEnded}
          disabled={null === selectedRange[0]}
          onClick={chooseOpenEnd}
        >
          {openEnd.label}
        </Button>
      </div>
    </div>
  );
}
